import styled from 'styled-components';
import { getThemeByPath } from '~/utils';

const primaryMain = getThemeByPath('colors.primary.main');
const secondaryMain = getThemeByPath('colors.secondary.main');

const bkpTablet = getThemeByPath('breakpoints.tablet');

const giantSpacing = getThemeByPath('spacings.giant');
const mediumSpacing = getThemeByPath('spacings.medium');

const defaultHeaderHeight = 233;

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${giantSpacing}px;
  background: linear-gradient(
    184deg,
    ${secondaryMain} -72.66%,
    ${primaryMain}00 58.37%
  );
  height: ${defaultHeaderHeight}px;

  @media (max-width: ${bkpTablet}px) {
    padding: ${mediumSpacing}px;
    height: fit-content;
  }
`;

export const ImageWrapper = styled.div`
  @media (max-width: ${bkpTablet}px) {
    margin: 0 ${mediumSpacing}px;
  }
`;

export const HeaderOptionsWrapper = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: space-around;
  padding: 0 ${mediumSpacing}px;
  margin: 0 ${giantSpacing}px;

  @media (max-width: ${bkpTablet}px) {
    display: none;
  }
`;

export const LinkWrapper = styled.div`
  margin: 0 ${mediumSpacing}px;
`;

export const MenuHamburguerWrapper = styled.div`
  display: none;

  @media (max-width: ${bkpTablet}px) {
    display: flex;
  }
`;

export const IconButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #0000;
`;

export const SectionWrapper = styled.div`
  padding: ${giantSpacing}px;

  @media (max-width: ${bkpTablet}px) {
    padding: ${mediumSpacing}px;
  }
`;
